import React, { createElement, useEffect, useRef, useState } from 'react';
import { Table, Message, Loading, Overlay, Balloon, Button, Icon } from '@alifd/next';
import { previewDataByField } from '../../../api/common/index';
import { fetchApplication } from '../../../api/report';
import TableHeader from './TableHeader';
import { dealArray, dealOrderByBoList, dom2image, exportExcel, getTextWidth, getSearchType, dealSymbol, dealFieldByList, formatPercentNumber, } from '../../../utils';
import './index.scss';
import ErrorBoundary from '../../common/errorBoundary';
import ErrorComponent from '../../common/errorComponent';
import { fIsMobile } from '../../../utils';
const { Popup } = Overlay;
const Tooltip = Balloon.Tooltip;
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const appid = urlParams.get('applicationId');
const ISummaryTable = (props, ref) => {
    const { dataSource, transposition, cols, theme, showSeqNum, fixedColumnlndex, headerBgColor, headerTextColor, hasTitle, titleText, descText, } = props;
    const [error, setError] = useState(false);
    const [errmsg, setErrmsg] = useState(null);
    const data = props.data.map((e, i) => ({ ...e, index: i + 1 }));
    const [idata, setIdata] = useState([]);
    const [icols, setIcols] = useState([]);
    const [itranspositionData, setItranspositionData] = useState([]);
    const [itranspositionProps, setItranspositionProps] = useState([]);
    const [loading, setLoading] = useState(false);
    const [sort, setSort] = useState([]);
    const pam = useRef(null);
    const [sumline, setSumLine] = useState({});
    const calculateTransposition = () => {
        try {
            let transpositionData = [];
            let transpositionProps = [{ dataIndex: 'title' }];
            const length = idata.length;
            const keys = icols.map((e) => e.dataIndex);
            for (let i = 0; i < keys.length; i++) {
                let obj = {
                    title: icols[i].title,
                };
                for (let j = 0; j < length; j++) {
                    if (i === 0) {
                        transpositionProps.push({
                            dataIndex: j + '',
                        });
                    }
                    obj[j] = idata[j][keys[i]];
                }
                transpositionData.push(obj);
            }
            setItranspositionProps(transpositionProps);
            setItranspositionData(transpositionData);
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('行列转置处理异常,请重新配置数据源字段或更新组件');
        }
    };
    const [openRowKeys, setOpenRowKeys] = useState([]);
    const popcell = (text, width) => {
        const popupProps = {
            animation: {
                in: 'zoomIn',
                out: 'zoomOut',
            },
            triggerType: 'hover',
            placementOffset: 4,
        };
        const w = getTextWidth(text) + 32;
        if (w > Number(width?.replace('px', ''))) {
            return (createElement(Popup, Object.assign({}, popupProps, { v2: true, trigger: createElement("div", { className: "popcell" }, text), placement: "t" }),
                createElement("div", { className: "popup" }, text)));
        }
        return text;
    };
    const renderCols = () => {
        return (transposition ? itranspositionProps : icols).map((col, index) => {
            const i = showSeqNum ? index + 1 : index;
            return (createElement(Table.Column, Object.assign({}, col, { key: col?.dataIndex, cell: (text) => popcell(text, col.width), sortable: true, sortDirections: ['desc', 'asc'] }, (fixedColumnlndex > i
                ? {
                    lock: 'left',
                }
                : {}))));
        });
    };
    useEffect(() => {
        setError(false);
        try {
            init(pam.current);
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('分页切换异常,请重新配置数据源字段或更新组件');
        }
    }, [dataSource]);
    useEffect(() => {
        try {
            if (transposition) {
                calculateTransposition();
            }
        }
        catch (error) {
            console.log(error);
            setError(false);
            setErrmsg('行列转置处理异常,请重新配置数据源字段或更新组件');
        }
    }, [idata, transposition]);
    const onSort = (dataIndex, order) => {
        const temp = JSON.parse(JSON.stringify(idata));
        const regex = /^\d+$/;
        const res = [
            ...temp.sort((a, b) => {
                if (order === 'desc') {
                    if (regex.test(b[dataIndex]) && regex.test(a[dataIndex])) {
                        return Number(b[dataIndex]) - Number(a[dataIndex]);
                    }
                    else {
                        return b[dataIndex].localeCompare(a[dataIndex]);
                    }
                }
                else {
                    if (regex.test(b[dataIndex]) && regex.test(a[dataIndex])) {
                        return Number(a[dataIndex]) - Number(b[dataIndex]);
                    }
                    else {
                        return a[dataIndex].localeCompare(b[dataIndex]);
                    }
                }
            }),
        ];
        setIdata(res);
    };
    const highlights = [];
    const getComputedStyle = (rowIndex, colIndex, dataIndex, record) => {
        try {
            let bgc = {};
            const find = highlights.find((e) => e.props === dataIndex);
            if (find) {
                if (record[dataIndex] > find.threshold) {
                    bgc = {
                        style: {
                            backgroundColor: find.color,
                        },
                    };
                }
            }
            return {
                ...bgc,
            };
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('单元格样式计算异常,请更新组件');
        }
    };
    const myExportExcel = async (parm = false) => {
        try {
            if (dataSource?.dimension?.length && dataSource?.target?.length) {
                setLoading(true);
                const reslut = await fetchApplication(appid);
                const title = reslut.data.applicationName;
                exportExcel([...idata, sumline], icols, `${title}_汇总表格`);
                setLoading(false);
            }
            else {
                const reslut = await fetchApplication(appid);
                const title = reslut.data.applicationName;
                exportExcel(data.map((e, i) => ({ ...e, index: i + 1 })), cols, `${title}_汇总表格`);
            }
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('导出异常,请重新配置数据源面板字段或更新组件');
        }
    };
    const init = (param = null) => {
        try {
            setLoading(true);
            if (dataSource?.dimension?.length && dataSource?.target?.length) {
                const fl = dataSource?.filter || [];
                const params = {
                    searchType: 'EXPORT',
                    groupId: dataSource.dataset.id,
                    type: 'SummaryTable',
                    fieldList: dealFieldByList([...dataSource.dimension, ...dataSource.target]),
                    orderByBoList: dealOrderByBoList(dataSource?.dimension),
                    longitudinalAxis: dealArray(dataSource?.target).map((e) => ({
                        ...e,
                        aggregateType: e?.aggregateType || 'COUNT',
                    })),
                    groupAxis: dealArray(dataSource.dimension),
                    customFilterVo: param
                        ? {
                            logic: 'and',
                            filterVos: [
                                dataSource?.filter[0],
                                ...Object.entries(param).map((item) => {
                                    const [name, value] = item;
                                    const field = dataSource.f.find((e) => e.name === name);
                                    if (value != undefined && value != '' && String(value) !== ',') {
                                        return {
                                            filed: field?.fieldShortName,
                                            filterValue: String(value),
                                            customFilterVo: String(value),
                                            symbol: dealSymbol(field?.additional?.relationship, field?.additional?.searchType || 'fuzzyQuery'),
                                            valueType: field?.type,
                                            filterType: getSearchType(field?.additional?.searchType || 'fuzzyQuery'),
                                        };
                                    }
                                }),
                            ].filter((e) => e && e.filterValue),
                        }
                        : fl[0] === undefined
                            ? null
                            : {
                                logic: 'and',
                                filterVos: [dataSource?.filter[0] || null].filter((e) => e),
                            },
                };
                if (dataSource?.calculate?.length > 0) {
                    const item = dataSource.calculate[0];
                    item.forEach((im) => {
                        const { alias, expr } = im;
                        params.fieldList.push({
                            alias,
                            type: 'cal',
                            filedId: '',
                        });
                        params.longitudinalAxis.push({
                            alias,
                            expr,
                            dataType: 'BIGINT',
                        });
                    });
                }
                previewDataByField(params)
                    .then((res) => {
                    const fields = res?.data?.fields;
                    if (!fields) {
                        Message.error(res?.msg);
                        return;
                    }
                    const minw = 50;
                    const maxw = 400;
                    const tempCols = [
                        ...dataSource.dimension,
                        ...dataSource.target,
                        ...(dataSource?.calculate[0] || []).map((e) => ({
                            name: e.alias,
                            fieldShortName: e.alias,
                        })),
                    ].map((e, i) => {
                        const list = [
                            (e?.additional?.alias || e.name) + (i ? '排11' : ''),
                            ...res.data.data.map((item) => item[e.fieldShortName]),
                        ];
                        let width = minw;
                        for (let i = 0; i < list.length; i++) {
                            const w = getTextWidth(list[i]) + 36;
                            if (width < w) {
                                width = Math.min(w, maxw);
                                if (width === 400)
                                    break;
                            }
                        }
                        return {
                            title: e?.additional?.alias || e.name,
                            dataIndex: e.fieldShortName,
                            width: `${width}px`,
                        };
                    });
                    const props = dataSource?.dimension[0].fieldShortName;
                    let temp = res.data.data;
                    setSort(dataSource?.dimension[0]?.additional?.sort ||
                        temp.slice(0, temp.length - 1).map((e) => ({ name: e[props], checked: true })));
                    temp[temp.length - 1][dataSource?.dimension[0].fieldShortName] = '总计:';
                    temp.forEach((item) => {
                        Object.keys(item).forEach((key) => {
                            if (key.includes('率')) {
                                item[key] = formatPercentNumber(item[key], 2);
                            }
                        });
                    });
                    const suml = temp.pop();
                    setSumLine(suml);
                    if (dataSource?.dimension[0]?.additional?.sort) {
                        const sortArr = dataSource?.dimension[0]?.additional?.sort.filter((e) => e.checked);
                        const sortList = [];
                        sortArr.forEach((item) => {
                            temp.forEach((itm) => {
                                if (itm[dataSource?.dimension[0]?.fieldShortName] === item.name) {
                                    sortList.push(itm);
                                }
                            });
                        });
                        temp = sortList;
                    }
                    setIdata(temp);
                    setIcols(tempCols);
                })
                    .finally(() => {
                    setLoading(false);
                });
            }
            else {
                setSort(data
                    .slice(0, data.length - 1)
                    .map((item) => ({ name: item[cols[0].dataIndex], checked: true })));
                let list = data.map((e, i) => ({ ...e, index: i + 1 }));
                const suml = list.pop();
                setIdata(list);
                setSumLine(suml);
                setIcols(cols);
                setLoading(false);
            }
        }
        catch (error) {
            console.log(error);
            setLoading(false);
            setError(true);
            setErrmsg('初始化数据出错,请在数据源面板重新配置字段或更新组件');
        }
    };
    const filterSearch = (param) => {
        try {
            if (dataSource?.dimension?.length && dataSource?.target?.length && param) {
                pam.current = param;
                init(param);
            }
            else {
                Message.show('暂无可查询数据!');
            }
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('过滤查询出错,请更新数据源面板字段或更新组件');
        }
    };
    const filterReset = () => {
        try {
            pam.current = null;
            init();
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('查询重置出错,请更新数据源面板字段或更新组件');
        }
    };
    const exporter = useRef();
    const exportImage = () => {
        setLoading(true);
        setTimeout(() => {
            dom2image(exporter.current, `${titleText || dataSource?.dataset?.name || '汇总表格'}_${new Date().toLocaleString()}.png`).finally(() => {
                setLoading(false);
            });
        }, 40);
    };
    const [isMoble, setIsMoble] = useState(fIsMobile());
    return (createElement(ErrorBoundary, null, error ? (createElement(ErrorComponent, { ref: ref, errmsg: errmsg })) : (createElement("div", { ref: ref, className: `table-${props.size} base_bg summary_table` },
        createElement(Loading, { visible: loading, fullScreen: true },
            createElement("div", { className: "flex-b" },
                hasTitle && dataSource?.dataset?.name ? (createElement("div", { className: "flex-s datasettitle" },
                    createElement("div", null, titleText || dataSource?.dataset?.name),
                    createElement(Tooltip, { v2: true, popupStyle: {
                            backgroundColor: '#1F2633',
                            color: '#fff',
                            borderRadius: '8px',
                        }, trigger: createElement("img", { style: { marginLeft: '8px' }, src: require('../../../assets/images/help.png'), alt: "" }) }, descText || '暂未配置描述'))) : (createElement("div", null)),
                isMoble ? null : (createElement("div", { className: "table_header" },
                    createElement(Button, { className: "export_btn", onClick: () => myExportExcel(pam.current), type: "normal" },
                        createElement(Icon, { type: "download" }),
                        "\u5BFC\u51FA"),
                    createElement(Button, { className: "export_btn img_btn", onClick: exportImage, type: "normal" },
                        createElement(Icon, { type: "download" }),
                        "\u5BFC\u51FA\u56FE\u7247")))),
            createElement(TableHeader, { dataset: dataSource?.dataset || null, field: dataSource?.f, filterSearch: filterSearch, filterReset: filterReset, exportExcel: () => myExportExcel(pam.current), setError: setError, setErrmsg: setErrmsg, exportImage: exportImage, appid: appid }),
            createElement("div", { ref: exporter },
                createElement(Table.StickyLock, { dataSource: transposition ? itranspositionData : [...idata, sumline], hasHeader: !transposition, fixedHeader: props.fixedHeader, maxBodyHeight: props.maxBodyHeight, isTree: props.isTree, isZebra: theme === 'zebra', hasBorder: theme === 'border', cellProps: (!transposition && getComputedStyle) || (() => { }), openRowKeys: openRowKeys, className: `${theme === 'noBorder' ? 'noBorder' : ''} ${transposition ? 'table-transposition' : ''}`, style: {
                        '--hbgc': headerBgColor || '#E4E7ED',
                        '--htc': headerTextColor || '#444',
                    }, onRowOpen: (openRowKeys) => {
                        setOpenRowKeys(openRowKeys);
                    }, onSort: onSort }, renderCols())))))));
};
export default React.forwardRef(ISummaryTable);
